import {
  DataGroup,
  NoticeType,
  PrintBorderpassData,
  PrintReceiptData,
  PrintStickerData,
  Request,
  RequestWithDuplicata
} from './request';
import {FormGroup} from '@angular/forms';

export enum DocsPrintType {
  APPROVAL_LETTER = 'APPROVAL_LETTER',
  DECISION_LETTER = 'DECISION_LETTER',
  RECEIPT = 'RECEIPT',
  STICKER = 'STICKER',
  BORDER_PASS = 'BORDER_PASS',
  APPLICATION = 'APPLICATION',
  SINGLE_DOCUMENT = 'SINGLE_DOCUMENT',
  QRCODE_LIST = 'QRCODE_LIST'
}

export type AllDocumentsPrintType = DocsPrintType | NoticeType;

export enum PaperSize {
  A4 = 'A4',
  A3 = 'A3',
  Letter = 'Letter',
  Thermal = 'Thermal',
  HalfLetter = 'HalfLetter'
}

export interface PrintSettingsDetails {
  defaultPrinter: string;
  colorMode: boolean;
  paperSize: PaperSize;
}

export interface PrintSettings {
  [DocsPrintType.APPLICATION]?: PrintSettingsDetails;
  [DocsPrintType.DECISION_LETTER]?: PrintSettingsDetails;
  [DocsPrintType.APPROVAL_LETTER]?: PrintSettingsDetails;
  [DocsPrintType.RECEIPT]?: PrintSettingsDetails;
  [DocsPrintType.STICKER]?: PrintSettingsDetails;
  [DocsPrintType.BORDER_PASS]?: PrintSettingsDetails;
  [DocsPrintType.SINGLE_DOCUMENT]?: PrintSettingsDetails;
  [NoticeType.RESTRICTION]?: PrintSettingsDetails;
  [NoticeType.REPORTING]?: PrintSettingsDetails;
  [NoticeType.REFUSAL]?: PrintSettingsDetails;
  [DocsPrintType.QRCODE_LIST]?: PrintSettingsDetails;
}

export interface PrintApplicationData {
  title: string;
  dataList: DataGroup[];
  request?: RequestWithDuplicata | Request;
}

export interface PrintNoticeData {
  form: FormGroup;
  qrCode: string;
}
export interface PrintNoticeRestrictionData extends PrintNoticeData {
  documents: string[];
}

export interface PrintQrCodeListData {
  title: string;
  dataList: RequestWithDuplicata[]
}

export const PrintableDocuments: {name: AllDocumentsPrintType, icon: string, active: boolean, data: any}[] = [
  {name: DocsPrintType.APPLICATION, icon: 'file', active: false, data: {} as PrintApplicationData},
  {name: DocsPrintType.DECISION_LETTER, icon: 'file', active: false, data: {} as PrintApplicationData},
  {name: DocsPrintType.APPROVAL_LETTER, icon: 'file', active: false, data: {} as RequestWithDuplicata},
  {name: DocsPrintType.RECEIPT, icon: 'receipt', active: false, data: {} as PrintReceiptData},
  {name: DocsPrintType.STICKER, icon: 'sticky-note', active: false, data: {} as PrintStickerData},
  {name: DocsPrintType.BORDER_PASS, icon: 'passport', active: false, data: {} as PrintBorderpassData},
  {name: DocsPrintType.SINGLE_DOCUMENT, icon: 'file', active: false, data: {} as PrintSingleDocument},
  {name: NoticeType.RESTRICTION, icon: 'file', active: false, data: {} as PrintNoticeRestrictionData},
  {name: NoticeType.REPORTING, icon: 'file', active: false, data: {} as PrintNoticeData},
  {name: NoticeType.REFUSAL, icon: 'file', active: false, data: {} as PrintNoticeData},
  {name: DocsPrintType.QRCODE_LIST, icon: 'file', active: false, data: {} as PrintQrCodeListData}
];

export interface PrintSingleDocument {
  img: string;
  title: string;
  date?: string;
  id?: string;
}

export interface StatusLabel {
  title: string;
  stickerLabel: string;
}
